import React from 'react';
import {useGetOppskrifter} from 'hooks/useGetOppskrifter';
import {Link as ReactLink} from 'react-router-dom';
import {Stack, Link, Text, Flex, Grid} from '@chakra-ui/react';
import {AddIcon, ArrowForwardIcon, EditIcon} from '@chakra-ui/icons';

const Oppskrifter: React.FC<{ edit?: boolean }> = ({edit = false}) => {
  const oppskrifter = useGetOppskrifter();
  // const families = useGetFamilies();

  if (!oppskrifter) return <Stack><Text>Det er ingen oppskrifter</Text></Stack>;
  // if (!families) return <Stack><Text>Det er ingen familier</Text></Stack>;

  const linkTo = (id: string) => edit ? `/edit/${id}` : `/oppskrift/${id}`;

  return (
    <Grid templateColumns="1fr 1fr">
      <Stack spacing={0}>
        {oppskrifter.map((oppskrift) => (
          <Link
            m={0}
            as={ReactLink}
            to={linkTo(oppskrift.id)}
            key={oppskrift.id}
          >
            <Flex
              m={0}
              p={2}
              align="center"
              fontSize={'xl'}
            >
              <Text>{oppskrift.title}</Text>
              {edit ? <EditIcon boxSize={3} ml={2} /> : <ArrowForwardIcon boxSize={3} ml={2} />}
            </Flex>
          </Link>
        ))}

      </Stack>
      <Link
        m={0}
        as={ReactLink}
        to={'/edit/'}
      >
        <Flex
          m={0}
          p={2}
          align="center"
          fontSize={'xl'}
        >
          <Text>Ny</Text>
          <AddIcon boxSize={3} ml={2} />
        </Flex>
      </Link>
    </Grid>
  );
};

export default Oppskrifter;
